import * as React from 'react';
import { shareConfig, SharePlatformDetail } from '../../../core/config';
import { isMobile } from '../../../utilities/browser';
import SvgImage from '../SvgImage';
import SharePaneProps from './type';
import './styles.scss';

const SharePane = ({
  sharePlatforms,
  isVertical,
  urlOverride,
}: SharePaneProps) => {
  const openShareDialog = (url: string, platform: string) => {
    const strWindowFeatures = 'resizable=yes,scrollbars=yes,status=yes,height=500,width=800';
    window.open(url, `Share on ${platform}`, strWindowFeatures);
  };

  const getBaseShareUrl = (platform: string) => (
    shareConfig.find(({ id }) => id === platform)
  )?.shareUrl;

  const share = (platform: SharePlatformDetail) => {
    let url = window.location.href;
    const title = document.title.replace('|', ' ');

    if (urlOverride) {
      url = urlOverride;
    }

    switch (platform.id) {
      case 'facebook':
        openShareDialog(`${getBaseShareUrl(platform.id)}${encodeURIComponent(url)}`, platform.id);
        break;
      case 'twitter':
        openShareDialog(`${getBaseShareUrl(platform.id)}${url}&text=${title}`, platform.id);
        break;
      case 'whatsapp':
        window.location.href = `${getBaseShareUrl(platform.id)}${title} | ${url}`;
        break;
      case 'copylink':
        // copyToClipBoard(url, () => {
        //   /* eslint-disable-next-line */
        //   alert('Link copied!');
        // });
        break;
      default:
        break;
    }
  };

  const handleDesktopClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const platform: SharePlatformDetail = shareConfig.find(
      ({ id }) => id === event.currentTarget.dataset.platform,
    ) || shareConfig[0];
    share(platform);
  };

  const handleMobileClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    navigator.share({ url: window.location.href });
  };

  return (
    <div className={`share-pane ${isVertical && 'share-pane--vertical'}`}>
      <ul>
        {sharePlatforms.map((sharePlatform) => (
          <React.Fragment key={sharePlatform.key}>
            {(!sharePlatform?.mobileOnly || (sharePlatform.mobileOnly && isMobile())) && (
              <li key={sharePlatform.id} className="share-pane__item">
                <button
                  title={sharePlatform.id}
                  onClick={
                    (event: React.MouseEvent<HTMLButtonElement>) => handleDesktopClick(event)
                  }
                  data-platform={sharePlatform.id}
                >
                  <SvgImage title={sharePlatform.id} reference={`#icon-${sharePlatform.id}`} />
                  <span className="visually-hidden">
                    {sharePlatform.id}
                  </span>
                </button>
              </li>
            )}
          </React.Fragment>
        ))}
        {navigator && typeof navigator.share === 'function' && (
          <li className="share-pane__item share-pane__item--mobile">
            <button title="Share" onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleMobileClick(event)}>
              <SvgImage title="Share" reference="#icon-share" />
              <span className="visually-hidden"> Share </span>
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default SharePane;
